// 这是一个用来配置pageview事件的配置表
// 只能配置router定义过的path，router.tsx
export const Event = {
  Web3PageView: 'Web3PageView',
  Web3UserClick: 'Web3UserClick',
};

export const Page = {
  Home: 'home',
};

export const pageViewConfigList = [
  {
    page_url: '',
    page_name: Page.Home,
  },
];
